module.exports = __webpack_public_path__ + "img/19.213929a7.jpg";